import { render, staticRenderFns } from "./setInfo.vue?vue&type=template&id=ca2aeda6&scoped=true&"
import script from "./setInfo.vue?vue&type=script&lang=js&"
export * from "./setInfo.vue?vue&type=script&lang=js&"
import style0 from "./setInfo.vue?vue&type=style&index=0&id=ca2aeda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2aeda6",
  null
  
)

export default component.exports